import { ELanguages } from '../types'
import { SelectOption } from '../components/Select/Select'

// Inline helper to avoid circular dependency with utils
const firstToUpperCase = (str: string) => {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const translations = {
  JenniinasReactPortfolio: {
    en: "Jenniina's React portfolio",
    es: 'Portafolio de React de Jenniina',
    fr: 'Portefeuille React de Jenniina',
    de: 'Jenniinas React-Portfolio',
    pt: 'Portfólio React da Jenniina',
    cs: 'React portfolio od Jenniiny',
    fi: 'Jenniinan React-portfolio',
  },
  YouMaySaveYourFavoriteJokesOrAddYourOwn: {
    en: 'You may save your favorite jokes or add your own when logged in.',
    es: 'Puede guardar sus chistes favoritos o agregar los suyos propios cuando inicie sesión.',
    fr: 'Vous pouvez enregistrer vos blagues préférées ou ajouter les vôtres lorsque vous êtes connecté.',
    de: 'Sie können Ihre Lieblingswitze speichern oder eigene hinzufügen, wenn Sie eingeloggt sind.',
    pt: 'Você pode salvar suas piadas favoritas ou adicionar as suas próprias quando estiver logado.',
    cs: 'Můžete uložit své oblíbené vtipy nebo přidat své vlastní, když jste přihlášeni.',
    fi: 'Voit tallentaa suosikkivitsisi tai lisätä omiasi, kun olet kirjautunut sisään.',
  },
  YouMayLogInToTheseSitesWithTheSameCredentials: {
    en: 'You may log in to these sites with the same credentials',
    es: 'Puedes iniciar sesión en estos sitios con las mismas credenciales',
    fr: 'Vous pouvez vous connecter à ces sites avec les mêmes identifiants',
    de: 'Sie können sich bei diesen Seiten mit denselben Anmeldeinformationen anmelden',
    pt: 'Você pode fazer login nesses sites com as mesmas credenciais',
    cs: 'Můžete se přihlásit na tyto stránky se stejnými přihlašovacími údaji',
    fi: 'Voit kirjautua näille sivustoille samoilla tunnuksilla',
  },
  PortfolioIntro: {
    en: 'Contains, among other things, a memory game and a quiz game and links to other projects by Jenniina.',
    es: 'Contiene, entre otras cosas, un juego de memoria y un juego de preguntas y respuestas, así como enlaces a otros proyectos de Jenniina.',
    fr: "Contient, entre autres, un jeu de mémoire et un jeu de quiz, ainsi que des liens vers d'autres projets de Jenniina.",
    de: 'Enthält unter anderem ein Memory-Spiel und ein Quiz-Spiel sowie Links zu anderen Projekten von Jenniina.',
    pt: 'Contém, entre outras coisas, um jogo de memória e um jogo de quiz, além de links para outros projetos de Jenniina.',
    cs: 'Obsahuje mimo jiné hru na paměť a kvízovou hru a odkazy na další projekty od Jenniina.',
    fi: 'Sisältää muun muassa muistipelin ja tietovisapelin sekä linkkejä Jenniinan muihin projekteihin.',
  },
  BlobAppIntro: {
    en: 'A custom draggables app with blobs that meld into each other.',
    es: 'Una aplicación personalizada de elementos arrastrables con blobs que se fusionan entre sí.',
    fr: "Une application personnalisée d'éléments glissables avec des blobs qui se fondent les uns dans les autres.",
    de: 'Eine benutzerdefinierte Drag & Drop-App mit Blobs, die ineinander übergehen.',
    pt: 'Um aplicativo personalizado de arrastáveis com blobs que se fundem entre si.',
    cs: 'Vlastní aplikace přetahování a přetažení s bloby, které se do sebe slévají.',
    fi: 'Raahattavat-sovellus, joka sisältää raahattavia toisiinsa sulautuvia mollukoita',
  },
  BlobArtApp: {
    en: 'Blob Art App',
    es: 'Aplicación de arte Blob',
    fr: 'Application d art Blob',
    de: 'Blob Art App',
    pt: 'Aplicativo de arte Blob',
    cs: 'Blob Art App',
    fi: 'Blob Art -sovellus',
  },
  JokeAppWithCustomizableOptions: {
    en: 'A joke app with customizable options',
    es: 'Una aplicación de chistes con opciones personalizables',
    fr: 'Une application de blagues avec des options personnalisables',
    de: 'Eine Witze-App mit anpassbaren Optionen',
    pt: 'Um aplicativo de piadas com opções personalizáveis',
    cs: 'Aplikace vtipů s možnostmi přizpůsobení',
    fi: 'Vitsisovellus, jossa on muokattavia vaihtoehtoja',
  },
  PrivacyPolicy: {
    en: 'Privacy policy',
    es: 'Política de privacidad',
    fr: 'Politique de confidentialité',
    de: 'Datenschutzrichtlinie',
    pt: 'Política de privacidade',
    cs: 'Zásady ochrany osobních údajů',
    fi: 'Tietosuojakäytäntö',
  },
  Privacy: {
    en: 'Privacy',
    es: 'Privacidad',
    fr: 'Confidentialité',
    de: 'Datenschutz',
    pt: 'Privacidade',
    cs: 'Soukromí',
    fi: 'Tietosuoja',
  },
  PrivacyAndDataSecurityInformation: {
    en: 'Privacy and data security information for the blob art tool',
    es: 'Información sobre privacidad y seguridad de datos para la herramienta de arte de blob',
    fr: "Informations sur la confidentialité et la sécurité des données pour l'outil d'art de blob",
    de: 'Informationen zum Datenschutz und zur Datensicherheit für das Blob-Kunstwerkzeug',
    pt: 'Informações sobre privacidade e segurança de dados para a ferramenta de arte de blob',
    cs: 'Informace o ochraně osobních údajů a bezpečnosti dat pro nástroj umění blob',
    fi: 'Tietosuojan ja tietoturvan tiedot mollukkataidetyökalulle',
  },
  PrivacyAndDataSecurityInformationForLoggedInUsers: {
    en: 'Privacy and data security information for logged in users of the joke application',
    es: 'Información sobre privacidad y seguridad de datos para usuarios registrados de la aplicación de chistes',
    fr: "Informations sur la confidentialité et la sécurité des données pour les utilisateurs connectés de l'application de blagues",
    de: 'Informationen zum Datenschutz und zur Datensicherheit für angemeldete Benutzer der Witzanwendung',
    pt: 'Informações sobre privacidade e segurança de dados para usuários conectados da aplicação de piadas',
    cs: 'Informace o ochraně osobních údajů a bezpečnosti dat pro přihlášené uživatele aplikace vtipů',
    fi: 'Tietosuojan ja tietoturvan tiedot vitsisovelluksen kirjautuneille käyttäjille',
  },
  ThisDisclaimerExplainsHowWeHandleYourPersonalData: {
    en: 'This disclaimer explains how we handle your personal data',
    es: 'Este descargo de responsabilidad explica cómo manejamos sus datos personales',
    fr: 'Cette clause de non-responsabilité explique comment nous traitons vos données personnelles',
    de: 'Dieser Haftungsausschluss erklärt, wie wir Ihre persönlichen Daten verarbeiten',
    pt: 'Este aviso legal explica como lidamos com seus dados pessoais',
    cs: 'Tento disclaimer vysvětluje, jak nakládáme s vašimi osobními údaji',
    fi: 'Tämä tietosuojakäytäntö selittää, miten käsittelemme henkilötietojasi',
  },
  ByUsingOurServiceYouAgreeToTheTermsOutlinedInThisDisclaimer: {
    en: 'By using our service, you agree to the terms outlined in this disclaimer',
    es: 'Al usar nuestro servicio, usted acepta los términos descritos en este descargo de responsabilidad',
    fr: 'En utilisant notre service, vous acceptez les termes décrits dans ce disclaimer',
    de: 'Durch die Nutzung unseres Dienstes stimmen Sie den in diesem Haftungsausschluss beschriebenen Bedingungen zu',
    pt: 'Ao usar nosso serviço, você concorda com os termos descritos neste aviso legal',
    cs: 'Používáním našich služeb souhlasíte s podmínkami uvedenými v tomto disclaimeru',
    fi: 'Käyttämällä palveluamme hyväksyt tässä vastuuvapauslausekkeessa esitetyt ehdot',
  },
  Updated: {
    en: 'Updated',
    es: 'Actualizado',
    fr: 'Mis à jour',
    de: 'Aktualisiert',
    pt: 'Atualizado',
    cs: 'Aktualizováno',
    fi: 'Päivitetty',
  },
  Settings: {
    en: 'Settings',
    es: 'Configuraciones',
    fr: 'Paramètres',
    de: 'Einstellungen',
    pt: 'Configurações',
    cs: 'Nastavení',
    fi: 'Asetukset',
  },
  AJokeGeneratorForTheComicallyInclined: {
    en: 'A Joke Generator for the Comically Inclined',
    es: 'Un generador de chistes para los cómicamente inclinados',
    fr: 'Un générateur de blagues pour les comiquement enclins',
    de: 'Ein Witzgenerator für die komisch geneigten',
    pt: 'Um gerador de piadas para os comicamente inclinados',
    cs: 'Generátor vtipů pro komicky nakloněné',
    fi: 'Vitsihaku vitsiniekoille',
  },
  AddWarningTitle: {
    en: 'Add Warning',
    es: 'Agregar advertencia',
    fr: 'Ajouter un avertissement',
    de: 'Warnung hinzufügen',
    pt: 'Adicionar aviso',
    cs: 'Přidat varování',
    fi: 'Lisää varoitus',
  },
  Age: {
    en: 'Age',
    es: 'Edad',
    fr: 'Âge',
    de: 'Alter',
    pt: 'Idade',
    cs: 'Věk',
    fi: 'Ikä',
  },
  All: {
    en: 'All',
    es: 'Todos',
    fr: 'Tout',
    de: 'Alle',
    pt: 'Todos',
    cs: 'Všechny',
    fi: 'Kaikki',
  },
  AllJokes: {
    en: 'All jokes',
    es: 'Todos los chistes',
    fr: 'Toutes les blagues',
    de: 'Alle Witze',
    pt: 'Todas as piadas',
    cs: 'Všechny vtipy',
    fi: 'Kaikki vitsit',
  },
  Anonymous: {
    en: 'Anonymous',
    es: 'Anónimo',
    fr: 'Anonyme',
    de: 'Anonym',
    pt: 'Anônimo',
    cs: 'Anonymní',
    fi: 'Anonyymi',
  },
  Any: {
    en: 'Any',
    es: 'Cualquiera',
    fr: "N'importe quel",
    de: 'Jede',
    pt: 'Qualquer',
    cs: 'Jakýkoliv',
    fi: 'Mikä tahansa',
  },
  AppTranslatedTo: {
    en: 'App translated to',
    es: 'Aplicación traducida a',
    fr: 'Application traduite en',
    de: 'App übersetzt nach',
    pt: 'Aplicativo traduzido para',
    cs: 'Aplikace přeložena do',
    fi: 'Sovellus käännetty',
  },
  AreYouSureYouWantToHideThisJoke: {
    en: 'Are you sure you want to hide this joke?',
    es: '¿Estás seguro de que quieres ocultar esta broma?',
    fr: 'Êtes-vous sûr de vouloir cacher cette blague?',
    de: 'Möchten Sie diesen Witz wirklich verstecken?',
    pt: 'Tem certeza de que deseja ocultar esta piada?',
    cs: 'Jste si jisti, že chcete tento vtip skrýt?',
    fi: 'Oletko varma, että haluat piilottaa tämän vitsin?',
  },
  AreYouSureYouWantToMakeThisJokePrivate: {
    en: 'Are you sure you want to make this joke private? Republishing will require verification from an administrator',
    es: '¿Estás seguro de que quieres hacer esta broma privada? Volver a publicar requerirá verificación de un administrador',
    fr: "Êtes-vous sûr de vouloir rendre cette blague privée? La republication nécessitera une vérification de la part d'un administrateur",
    de: 'Möchten Sie diesen Witz wirklich privat machen? Eine erneute Veröffentlichung erfordert eine Überprüfung durch einen Administrator',
    pt: 'Tem certeza de que deseja tornar esta piada privada? Republicar exigirá verificação de um administrador',
    cs: 'Jste si jisti, že chcete tento vtip udělat soukromým? Opětovné zveřejnění bude vyžadovat ověření od správce',
    fi: 'Oletko varma, että haluat tehdä tämän vitsin yksityiseksi? Uudelleenjulkaisu vaatii vahvistuksen hallinnolta',
  },
  AreYouSureYouWantToMakeThisJokePublic: {
    en: 'Are you sure you want to make this joke public? It will need verification from an administrator',
    es: '¿Estás seguro de que quieres hacer esta broma pública? Necesitará verificación de un administrador',
    fr: "Êtes-vous sûr de vouloir rendre cette blague publique? Il aura besoin d'une vérification de la part d'un administrateur",
    de: 'Möchten Sie diesen Witz wirklich öffentlich machen? Es wird eine Überprüfung durch einen Administrator benötigt',
    pt: 'Tem certeza de que deseja tornar esta piada pública? Ele precisará de verificação de um administrador',
    cs: 'Jste si jisti, že chcete tento vtip zveřejnit? Bude potřebovat ověření od správce',
    fi: 'Oletko varma, että haluat tehdä tämän vitsin julkiseksi? Se vaatii vahvistuksen hallinnolta',
  },
  AreYouSureYouWantToRestoreThisJoke: {
    en: 'Are you sure you want to restore this joke?',
    es: '¿Estás seguro de que quieres restaurar esta broma?',
    fr: 'Êtes-vous sûr de vouloir restaurer cette blague?',
    de: 'Möchten Sie diesen Witz wirklich wiederherstellen?',
    pt: 'Tem certeza de que deseja restaurar esta piada?',
    cs: 'Jste si jisti, že chcete tento vtip obnovit?',
    fi: 'Oletko varma, että haluat palauttaa tämän vitsin?',
  },
  Author: {
    en: 'Author',
    es: 'Autor',
    fr: 'Auteur',
    de: 'Autor',
    pt: 'Autor',
    cs: 'Autor',
    fi: 'Tekijä',
  },
  Back: {
    en: 'Back',
    es: 'Atrás',
    fr: 'Retour',
    de: 'Zurück',
    pt: 'Voltar',
    cs: 'Zpět',
    fi: 'Takaisin',
  },
  Block: {
    en: 'Block',
    es: 'Bloquear',
    fr: 'Bloquer',
    de: 'Block',
    pt: 'Bloquear',
    cs: 'Blok',
    fi: 'Estä',
  },
  Blocked: {
    en: 'Blocked',
    es: 'Bloqueado',
    fr: 'Bloqué',
    de: 'Blockiert',
    pt: 'Bloqueado',
    cs: 'Blokovaný',
    fi: 'Estetyt',
  },
  BlacklistTheJoke: {
    en: 'Blacklist the joke',
    es: 'Poner el chiste en la lista negra',
    fr: 'Mettre la blague sur liste noire',
    de: 'Den Witz auf die schwarze Liste setzen',
    pt: 'Colocar a piada na lista negra',
    cs: 'Přidat vtip na černou listinu',
    fi: 'Lisää vitsi mustalle listalle',
  },
  Cancel: {
    en: 'Cancel',
    es: 'Cancelar',
    fr: 'Annuler',
    de: 'Abbrechen',
    pt: 'Cancelar',
    cs: 'Zrušit',
    fi: 'Peruuta',
  },
  CategoryTitle: {
    en: 'Category',
    es: 'Categoría',
    fr: 'Catégorie',
    de: 'Kategorie',
    pt: 'Categoria',
    cs: 'Kategorie',
    fi: 'Kategoria',
  },
  Clear: {
    en: 'Clear',
    es: 'Limpiar',
    fr: 'Effacer',
    de: 'Löschen',
    pt: 'Limpar',
    cs: 'Vymazat',
    fi: 'Tyhjennä',
  },
  ClickHereToSeeFeatures: {
    en: 'Click here to see the features',
    cs: 'Klikněte zde pro zobrazení funkcí',
    de: 'Klicken Sie hier, um die Funktionen anzuzeigen',
    es: 'Haga clic aquí para ver las funciones',
    fr: 'Cliquez ici pour voir les fonctionnalités',
    pt: 'Clique aqui para ver os recursos',
    fi: 'Napsauta tätä nähdäksesi eri ominaisuudet',
  },
  ClickHereToWriteYourOwnJoke: {
    en: 'Click here to write your own joke',
    es: 'Haga clic aquí para escribir su propia broma',
    fr: 'Cliquez ici pour écrire votre propre blague',
    de: 'Klicken Sie hier, um Ihren eigenen Witz zu schreiben',
    pt: 'Clique aqui para escrever sua própria piada',
    cs: 'Kliknutím sem napíšete vlastní vtip',
    fi: 'Napsauta tätä kirjoittaaksesi oman vitsisi',
  },
  ClickToReveal: {
    en: 'Click to reveal',
    es: 'Clic para revelar',
    fr: 'Cliquez pour révéler',
    de: 'Klicken Sie zum Enthüllen',
    pt: 'Clique para revelar',
    cs: 'Kliknutím zobrazíte',
    fi: 'Napsauta paljastaaksesi',
  },
  Close: {
    en: 'Close',
    es: 'Cerrar',
    fr: 'Fermer',
    de: 'Schließen',
    pt: 'Fechar',
    cs: 'Zavřít',
    fi: 'Sulje',
  },
  Confirm: {
    en: 'Confirm',
    es: 'Confirmar',
    fr: 'Confirmer',
    de: 'Bestätigen',
    pt: 'Confirmar',
    cs: 'Potvrdit',
    fi: 'Vahvista',
  },
  ConfirmPassword: {
    en: 'Confirm Password',
    es: 'Confirmar contraseña',
    fr: 'Confirmez le mot de passe',
    de: 'Passwort bestätigen',
    pt: 'Confirme a Senha',
    cs: 'Potvrďte heslo',
    fi: 'Vahvista salasana',
  },
  CopiedToClipboard: {
    en: 'Copied to clipboard!',
    es: '¡Copiado al portapapeles!',
    fr: 'Copié dans le presse-papiers!',
    de: 'In die Zwischenablage kopiert!',
    pt: 'Copiado para a área de transferência!',
    cs: 'Zkopírováno do schránky!',
    fi: 'Kopioitu leikepöydälle!',
  },
  Copy: {
    en: 'Copy',
    es: 'Copiar',
    fr: 'Copier',
    de: 'Kopieren',
    pt: 'Copiar',
    cs: 'Kopírovat',
    fi: 'Kopioi',
  },
  CopyToClipboard: {
    en: 'Copy to clipboard',
    es: 'Copiar al portapapeles',
    fr: 'Copier dans le presse-papiers',
    de: 'In die Zwischenablage kopieren',
    pt: 'Copiar para a área de transferência',
    cs: 'Kopírovat do schránky',
    fi: 'Kopioi leikepöydälle',
  },
  CopyAddressToClipboard: {
    en: 'Copy address to clipboard',
    es: 'Copiar dirección al portapapeles',
    fr: 'Copier l adresse dans le presse-papiers',
    de: 'Adresse in die Zwischenablage kopieren',
    pt: 'Copiar endereço para a área de transferência',
    cs: 'Kopírovat adresu do schránky',
    fi: 'Kopioi osoite leikepöydälle',
  },
  DarkJokesAreVisibleOnlyWhenSafeModeIsOff: {
    en: '"Dark" jokes are visible only when Safe Mode is off',
    es: 'Las "bromas oscuras" son visibles solo cuando el Modo seguro está desactivado',
    fr: 'Les "blagues sombres" ne sont visibles que lorsque le mode sécurisé est désactivé',
    de: 'Die "dunklen" Witze sind nur sichtbar, wenn der sichere Modus deaktiviert ist',
    pt: 'As "piadas escuras" são visíveis apenas quando o Modo de segurança está desativado',
    cs: '"Temné" vtipy jsou viditelné pouze tehdy, když je bezpečný režim vypnutý',
    fi: 'Synkät (Dark) vitsit näkyvät vain, kun turvallinen tila on pois päältä',
  },
  DarkMode: {
    en: 'Dark Mode',
    es: 'Modo Oscuro',
    fr: 'Mode Sombre',
    de: 'Dunkler Modus',
    pt: 'Modo Escuro',
    cs: 'Tmavý Režim',
    fi: 'Tumma tila',
  },
  Delete: {
    en: 'Delete',
    es: 'Eliminar',
    fr: 'Supprimer',
    de: 'Löschen',
    pt: 'Excluir',
    cs: 'Odstranit',
    fi: 'Poista',
  },
  Edit: {
    en: 'Edit',
    es: 'Editar',
    fr: 'Modifier',
    de: 'Bearbeiten',
    pt: 'Editar',
    cs: 'Upravit',
    fi: 'Muokkaa',
  },
  Email: {
    en: 'Email',
    es: 'Correo electrónico',
    fr: 'Email',
    de: 'Email',
    pt: 'O email',
    cs: 'E-mailem',
    fi: 'Sähköposti',
  },
  EmailSent: {
    en: 'Email sent',
    es: 'Correo electrónico enviado',
    fr: 'Email envoyé',
    de: 'E-Mail gesendet',
    pt: 'Email enviado',
    cs: 'E-mail odeslán',
    fi: 'Sähköposti lähetetty',
  },
  Error: {
    en: 'Error',
    es: 'Error',
    fr: 'Erreur',
    de: 'Error',
    pt: 'Erro',
    cs: 'Chyba',
    fi: 'Virhe',
  },
  ErrorDeletingJoke: {
    en: 'There was an error deleting the joke',
    es: 'Se produjo un error al eliminar la broma',
    fr: "Une erreur s'est produite lors de la suppression de la blague",
    de: 'Beim Löschen des Witzes ist ein Fehler aufgetreten',
    pt: 'Ocorreu um erro ao excluir a piada',
    cs: 'Při mazání vtipu došlo k chybě',
    fi: 'Vitsin poistamisessa tapahtui virhe',
  },
  Etc: {
    en: 'etc.',
    es: 'etc.',
    fr: 'etc.',
    de: 'etc.',
    pt: 'etc.',
    cs: 'atd.',
    fi: 'jne.',
  },
  ExitToMainSite: {
    en: 'Exit to Main Site',
    es: 'Salir al sitio principal',
    fr: 'Quitter le site principal',
    de: 'Zum Hauptstandort wechseln',
    pt: 'Sair para o site principal',
    cs: 'Ukončit na hlavní stránku',
    fi: 'Poistu pääsivulle',
  },
  FailedToCopy: {
    en: 'Failed to copy!',
    es: '¡Error al copiar!',
    fr: 'Échec de la copie!',
    de: 'Kopieren fehlgeschlagen!',
    pt: 'Falha ao copiar!',
    cs: 'Kopírování se nezdařilo!',
    fi: 'Kopiointi epäonnistui!',
  },
  FailedToCopyJokeToClipboard: {
    en: 'Failed to copy joke to clipboard',
    es: 'Error al copiar la broma al portapapeles',
    fr: 'Impossible de copier la blague dans le presse-papiers',
    de: 'Fehler beim Kopieren des Witzes in die Zwischenablage',
    pt: 'Falha ao copiar piada para a área de transferência',
    cs: 'Chyba při kopírování vtipu do schránky',
    fi: 'Vitsin kopioiminen leikepöydälle epäonnistui',
  },
  Features: {
    en: 'Features',
    es: 'Caracteristicas',
    fr: 'Traits',
    de: 'Eigenschaften',
    pt: 'Características',
    cs: 'Vlastnosti',
    fi: 'Ominaisuudet',
  },
  FetchesJokesFrom: {
    en: 'Fetches jokes from',
    es: 'Busca chistes de',
    fr: 'Récupère des blagues de',
    de: 'Holt sich Witze von',
    pt: 'Busca piadas de',
    cs: 'Načte vtipy z',
    fi: 'Noutaa vitsejä sijainnista',
  },
  Filter: {
    en: 'Filter',
    es: 'Filtrar',
    fr: 'Filtre',
    de: 'Filter',
    pt: 'Filtro',
    cs: 'Filtr',
    fi: 'Suodata',
  },
  FilterByCategory: {
    en: 'Filter by category',
    es: 'Filtrar por categoría',
    fr: 'Filtrer par catégorie',
    de: 'Nach Kategorie filtern',
    pt: 'Filtrar por categoria',
    cs: 'Filtrovat podle kategorie',
    fi: 'Suodata kategorian mukaan',
  },
  FilterByLanguage: {
    en: 'Filter by language',
    es: 'Filtrar por idioma',
    fr: 'Filtrer par langue',
    de: 'Nach Sprache filtern',
    pt: 'Filtrar por idioma',
    cs: 'Filtrovat podle jazyka',
    fi: 'Suodata kielen mukaan',
  },
  FilterFurther: {
    en: 'Filter further',
    es: 'Filtrar más',
    fr: 'Filtrer davantage',
    de: 'Weiter filtern',
    pt: 'Filtrar mais',
    cs: 'Filtrovat dále',
    fi: 'Suodata lisää',
  },
  FilterJokesBy: {
    en: 'Filter jokes by',
    es: 'Filtrar chistes por',
    fr: 'Filtrer les blagues par',
    de: 'Filtern Sie Witze nach',
    pt: 'Filtrar piadas por',
    cs: 'Filtrovat vtipy podle',
    fi: 'Suodata vitsejä:',
  },
  FirstPage: {
    en: 'First page',
    es: 'Primera página',
    fr: 'Première page',
    de: 'Erste Seite',
    pt: 'Primeira página',
    cs: 'První stránka',
    fi: 'Ensimmäinen sivu',
  },
  ForgotPassword: {
    en: 'Forgot Password?',
    es: '¿Olvidaste tu contraseña?',
    fr: 'Mot de passe oublié?',
    de: 'Passwort vergessen?',
    pt: 'Esqueceu a senha?',
    cs: 'Zapomněli jste heslo?',
    fi: 'Unohtuiko salasana?',
  },
  HideBlockedJokes: {
    en: 'Hide blocked jokes',
    es: 'Ocultar bromas bloqueadas',
    fr: 'Masquer les blagues bloquées',
    de: 'Blockierte Witze ausblenden',
    pt: 'Ocultar piadas bloqueadas',
    cs: 'Skrýt blokované vtipy',
    fi: 'Piilota estetyt vitsit',
  },
  HowMany: {
    en: 'How many',
    es: 'Cuántos',
    fr: 'Combien',
    de: 'Wie viele',
    pt: 'Quantos',
    cs: 'Kolik',
    fi: 'Kuinka monta',
  },
  IfTheJokeIsNotPrivateVerificationIsNeeded: {
    en: 'If the joke is not private, verification is needed from the administrator',
    es: 'Si la broma no es privada, se necesita verificación del administrador',
    fr: "Si la blague n'est pas privée, une vérification est nécessaire de la part de l'administrateur",
    de: 'Wenn der Witz nicht privat ist, ist eine Überprüfung durch den Administrator erforderlich',
    pt: 'Se a piada não for particular, é necessária verificação do administrador',
    cs: 'Pokud vtip není soukromý, je potřeba ověření od správce',
    fi: 'Jos vitsi ei ole yksityinen, tarvitaan hallinnon vahvistus',
  },
  Joke: {
    en: 'Joke',
    es: 'Chiste',
    fr: 'Blague',
    de: 'Witz',
    pt: 'Piada',
    cs: 'Vtip',
    fi: 'Vitsi',
  },
  JokeAlreadySaved: {
    en: 'Joke already saved',
    es: 'Chiste ya guardado',
    fr: 'Blague déjà enregistrée',
    de: 'Witz bereits gespeichert',
    pt: 'Piada já salva',
    cs: 'Vtip již uložen',
    fi: 'Vitsi on jo tallennettu',
  },
  JokeCopiedToClipboard: {
    en: 'Joke copied to clipboard',
    es: 'Broma copiada al portapapeles',
    fr: 'Blague copiée dans le presse-papiers',
    de: 'Witz in die Zwischenablage kopiert',
    pt: 'Piada copiada para a área de transferência',
    cs: 'Vtip zkopírován do schránky',
    fi: 'Vitsi kopioitu leikepöydälle',
  },
  JokeDelivery: {
    en: 'Punchline',
    es: 'Remate',
    fr: 'Pointe',
    de: 'Pointe',
    pt: 'Punchline',
    cs: 'Pointe',
    fi: 'Huipennus',
  },
  JokeHidden: {
    en: 'Joke hidden',
    es: 'Broma oculta',
    fr: 'Blague cachée',
    de: 'Witz versteckt',
    pt: 'Piada escondida',
    cs: 'Vtip skrytý',
    fi: 'Vitsi piilotettu',
  },
  JokeIsSetToPrivateAndWillOnlyBeSeenByYouAndTheAdministrator: {
    en: 'Joke is set to private and will only be seen by you and the administrator',
    es: 'La broma está configurada como privada y solo será visible para usted y el administrador',
    fr: "La blague est définie sur privée et ne sera visible que par vous et l'administrateur",
    de: 'Der Witz ist auf privat eingestellt und wird nur von Ihnen und dem Administrator gesehen',
    pt: 'A piada é definida como privada e só será vista por você e pelo administrador',
    cs: 'Vtip je nastaven na soukromý a uvidíte ho pouze vy a správce',
    fi: 'Vitsi on asetettu yksityiseksi ja sitä näkevät vain sinä ja hallinto',
  },
  JokeLanguage: {
    en: 'Joke language',
    es: 'Idioma de la broma',
    fr: 'Langue de la blague',
    de: 'Witzsprache',
    pt: 'Idioma da piada',
    cs: 'Jazyk vtipu',
    fi: 'Vitsin kieli',
  },
  JokeRestored: {
    en: 'Joke restored',
    es: 'Broma restaurada',
    fr: 'Blague restaurée',
    de: 'Witz wiederhergestellt',
    pt: 'Piada restaurada',
    cs: 'Vtip obnoven',
    fi: 'Vitsi palautettu',
  },
  JokeSetup: {
    en: 'Setup',
    es: 'Configurar',
    fr: 'Configuration',
    de: 'Einrichtung',
    pt: 'Configuração',
    cs: 'Nastavení',
    fi: 'Pohjustus',
  },
  JokeTypeTitle: {
    en: 'Joke Type',
    es: 'Tipo de broma',
    fr: 'Type de blague',
    de: 'Witzart',
    pt: 'Tipo de piada',
    cs: 'Typ vtipu',
    fi: 'Vitsityyppi',
  },
  Jokes: {
    en: 'Jokes',
    es: 'Chistes',
    fr: 'Blagues',
    de: 'Witze',
    pt: 'Piadas',
    cs: 'Vtipy',
    fi: 'Vitsit',
  },
  TheJokesAppUsesTheFollowingAPIsToFetchJokes: {
    en: 'The jokes app uses the following APIs to fetch jokes',
    es: 'La aplicación de chistes utiliza las siguientes API para recuperar chistes',
    fr: "L'application de blagues utilise les API suivantes pour récupérer des blagues",
    de: 'Die Witze-App verwendet die folgenden APIs, um Witze abzurufen',
    pt: 'O aplicativo de piadas usa as seguintes APIs para buscar piadas',
    cs: 'Aplikace vtipů používá následující API k načítání vtipů',
    fi: 'Vitsisovellus käyttää seuraavia API:ita hakeakseen vitsejä',
  },
  FetchesJokesFromAMongoDBDatabase: {
    en: 'Fetches jokes from a MongoDB database',
    es: 'Recupera chistes de una base de datos MongoDB',
    fr: 'Récupère des blagues à partir d une base de données MongoDB',
    de: 'Holt Witze aus einer MongoDB-Datenbank',
    pt: 'Busca piadas de um banco de dados MongoDB',
    cs: 'Načítá vtipy z databáze MongoDB',
    fi: 'Hakee vitsejä MongoDB-tietokannasta',
  },
  By: {
    en: 'By',
    es: 'Por',
    fr: 'Par',
    de: 'Von',
    pt: 'Por',
    cs: 'Od',
    fi: 'Toteuttanut',
  },
  Info: {
    en: 'Info',
    es: 'Información',
    fr: 'Info',
    de: 'Info',
    pt: 'Informação',
    cs: 'Info',
    fi: 'Info',
  },
  JokesLoaded: {
    en: 'Jokes loaded',
    es: 'Bromas cargadas',
    fr: 'Blagues chargées',
    de: 'Witze geladen',
    pt: 'Piadas carregadas',
    cs: 'Vtipy načteny',
    fi: 'Vitsit ladattu',
  },
  Keyword: {
    en: 'Keyword',
    es: 'Palabra clave',
    fr: 'Mot-clé',
    de: 'Stichwort',
    pt: 'Palavra-chave',
    cs: 'Klíčové slovo',
    fi: 'Avainsana',
  },
  LanguageTitle: {
    en: 'Language',
    es: 'Idioma',
    fr: 'Langue',
    de: 'Sprache',
    pt: 'Língua',
    cs: 'Jazyk',
    fi: 'Kieli',
  },
  LanguagesLong: {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    pt: 'Português',
    cs: 'Čeština',
    fi: 'Suomi',
  },
  LastPage: {
    en: 'Last page',
    es: 'Última página',
    fr: 'Dernière page',
    de: 'Letzte Seite',
    pt: 'Última página',
    cs: 'Poslední stránka',
    fi: 'Viimeinen sivu',
  },
  Latest: {
    en: 'Latest',
    es: 'Últimos',
    fr: 'Derniers',
    de: 'Letzte',
    pt: 'Últimos',
    cs: 'Posledních',
    fi: 'Viimeisimmät',
  },
  LightMode: {
    en: 'Light Mode',
    es: 'Modo Claro',
    fr: 'Mode Lumière',
    de: 'Lichtmodus',
    pt: 'Modo Claro',
    cs: 'Světlý Režim',
    fi: 'Vaalea tila',
  },
  LoadingJokes: {
    en: 'Loading jokes...',
    es: 'Cargando bromas...',
    fr: 'Chargement des blagues...',
    de: 'Witze werden geladen...',
    pt: 'Carregando piadas...',
    cs: 'Načítání vtipů...',
    fi: 'Ladataan vitsejä...',
  },
  LocalJokes: {
    en: 'Local jokes',
    es: 'Chistes locales',
    fr: 'Blagues locales',
    de: 'Lokale Witze',
    pt: 'Piadas locais',
    cs: 'Místní vtipy',
    fi: 'Paikalliset vitsit',
  },
  LoggedInAs: {
    en: 'Logged in as',
    es: 'Conectado como',
    fr: 'Connecté en tant que',
    de: 'Angemeldet als',
    pt: 'Conectado como',
    cs: 'Přihlášen jako',
    fi: 'Kirjautuneena tunnuksella',
  },
  UserUpdated: {
    en: 'User updated',
    es: 'Usuario actualizado',
    fr: 'Utilisateur mis à jour',
    de: 'Benutzer aktualisiert',
    pt: 'Usuário atualizado',
    cs: 'Uživatel aktualizován',
    fi: 'Käyttäjä päivitetty',
  },
  Home: {
    en: 'Home',
    es: 'Inicio',
    fr: 'Accueil',
    de: 'Startseite',
    pt: 'Início',
    cs: 'Domů',
    fi: 'Koti',
  },
  CannotBeChangedForTestUser: {
    en: 'Cannot be changed for test user',
    es: 'No se puede cambiar para el usuario de prueba',
    fr: "Ne peut pas être modifié pour l'utilisateur de test",
    de: 'Kann für Testbenutzer nicht geändert werden',
    pt: 'Não pode ser alterado para o usuário de teste',
    cs: 'Nelze změnit pro testovacího uživatele',
    fi: 'Ei voi muuttaa testikäyttäjälle',
  },
  UserNotUpdated: {
    en: 'User not updated',
    es: 'Usuario no actualizado',
    fr: 'Utilisateur non mis à jour',
    de: 'Benutzer nicht aktualisiert',
    pt: 'Usuário não atualizado',
    cs: 'Uživatel nebyl aktualizován',
    fi: 'Käyttäjää ei päivitetty',
  },
  PasswordMustBeAtLeastTenCharacters: {
    en: 'Password must be at least ten characters',
    es: 'La contraseña debe tener al menos diez caracteres',
    fr: 'Le mot de passe doit comporter au moins dix caractères',
    de: 'Das Passwort muss mindestens zehn Zeichen lang sein',
    pt: 'A senha deve ter pelo menos dez caracteres',
    cs: 'Heslo musí mít alespoň deset znaků',
    fi: 'Salasanan tulee olla vähintään kymmenen merkkiä pitkä',
  },
  CurrentPassword: {
    en: 'Current password',
    es: 'Contraseña actual',
    fr: 'Mot de passe actuel',
    de: 'Aktuelles Passwort',
    pt: 'Senha atual',
    cs: 'Aktuální heslo',
    fi: 'Nykyinen salasana',
  },
  UsernameIsTheSame: {
    en: 'Username is the same as before',
    es: 'El nombre de usuario es el mismo que antes',
    fr: "Le nom d'utilisateur est le même qu'avant",
    de: 'Der Benutzername ist derselbe wie zuvor',
    pt: 'O nome de usuário é o mesmo de antes',
    cs: 'Uživatelské jméno je stejné jako předtím',
    fi: 'Käyttäjätunnus on sama kuin aiemmin',
  },
  CurrentNickname: {
    en: 'Current nickname',
    es: 'Apodo actual',
    fr: 'Surnom actuel',
    de: 'Aktueller Spitzname',
    pt: 'Apelido atual',
    cs: 'Aktuální přezdívka',
    fi: 'Nykyinen nimimerkki',
  },
  LoggedOut: {
    en: 'Logged out',
    es: 'Desconectado',
    fr: 'Déconnecté',
    de: 'Ausgeloggt',
    pt: 'Desconectado',
    cs: 'Odhlášeno',
    fi: 'Kirjauduttu ulos',
  },
  LoggingIn: {
    en: 'Logging in...',
    es: 'Iniciando sesión...',
    fr: 'Connexion en cours...',
    de: 'Anmeldung...',
    pt: 'Entrando...',
    cs: 'Přihlašování...',
    fi: 'Kirjaudutaan...',
  },
  Login: {
    en: 'Log In',
    es: 'Iniciar sesión',
    fr: "S'identifier",
    de: 'Einloggen',
    pt: 'Entrar',
    cs: 'Přihlásit se',
    fi: 'Kirjaudu sisään',
  },
  LoginOrRegisterToSave: {
    en: 'Please login or register to save the joke',
    es: 'Por favor inicie sesión o regístrese para guardar la broma',
    fr: 'Veuillez vous connecter ou vous inscrire pour enregistrer la blague',
    de: 'Bitte melden Sie sich an oder registrieren Sie sich, um den Witz zu speichern',
    pt: 'Por favor, faça login ou registre-se para salvar a piada',
    cs: 'Přihlaste se nebo se zaregistrujte, abyste uložili vtip',
    fi: 'Kirjaudu sisään tai rekisteröidy tallentaaksesi vitsin',
  },
  Logout: {
    en: 'Log Out',
    es: 'Cerrar sesión',
    fr: 'Se déconnecter',
    de: 'Ausloggen',
    pt: 'Sair',
    cs: 'Odhlásit se',
    fi: 'Kirjaudu ulos',
  },
  Newest: {
    en: 'Newest',
    es: 'El más nuevo',
    fr: 'Le plus récent',
    de: 'Neueste',
    pt: 'Mais novo',
    cs: 'Nejnovější',
    fi: 'Uusin',
  },
  Next: {
    en: 'Next',
    es: 'Siguiente',
    fr: 'Suivant',
    de: 'Nächste',
    pt: 'Próximo',
    cs: 'Další',
    fi: 'Seuraava',
  },
  Nickname: {
    en: 'Nickname',
    es: 'Apodo',
    fr: 'Surnom',
    de: 'Spitzname',
    pt: 'Apelido',
    cs: 'Přezdívka',
    fi: 'Nimimerkki',
  },
  NoJokeFound: {
    en: 'No joke found',
    es: 'No se encontró broma',
    fr: 'Pas de blague trouvée',
    de: 'Kein Witz gefunden',
    pt: 'Nenhuma piada encontrada',
    cs: 'Nenalezen žádný vtip',
    fi: 'Vitsiä ei löytynyt',
  },
  NoJokeFoundWithThisSearchTerm: {
    en: 'No joke found with this search term',
    es: 'No se encontró broma con este término de búsqueda',
    fr: 'Pas de blague trouvée avec ce terme de recherche',
    de: 'Kein Witz mit diesem Suchbegriff gefunden',
    pt: 'Nenhuma piada encontrada com este termo de pesquisa',
    cs: 'Nenalezen žádný vtip s tímto vyhledávacím výrazem',
    fi: 'Vitsiä ei löytynyt tällä hakusanalla',
  },
  NoJokesYet: {
    en: 'No jokes yet',
    es: 'Aún no hay bromas',
    fr: 'Pas encore de blagues',
    de: 'Noch keine Witze',
    pt: 'Ainda não há piadas',
    cs: 'Zatím žádné vtipy',
    fi: 'Ei vielä vitsejä',
  },
  Note: {
    en: 'Note!',
    es: '¡Nota!',
    fr: 'Remarque!',
    de: 'Hinweis!',
    pt: 'Nota!',
    cs: 'Poznámka!',
    fi: 'Huom!',
  },
  Oldest: {
    en: 'Oldest',
    es: 'El más antiguo',
    fr: 'Le plus ancien',
    de: 'Älteste',
    pt: 'Mais antigo',
    cs: 'Nejstarší',
    fi: 'Vanhin',
  },
  OnOff: {
    en: 'On/Off',
    es: 'Encendido/Apagado',
    fr: 'Activé/Désactivé',
    de: 'Ein/Aus',
    pt: 'Ligado/Desligado',
    cs: 'Zapnuto/Vypnuto',
    fi: 'Päällä/Pois',
  },
  OnlyPrivateJokesCanBeEdited: {
    en: 'The text of jokes can be edited only when private',
    es: 'El texto de las bromas solo se puede editar cuando es privado',
    fr: "Le texte des blagues ne peut être modifié que lorsqu'il est privé",
    de: 'Der Text von Witzen kann nur bearbeitet werden, wenn er privat ist',
    pt: 'O texto das piadas só pode ser editado quando privado',
    cs: 'Text vtipů lze upravovat pouze v případě soukromého',
    fi: 'Vitsien tekstiä voi muokata vain silloin, kun se on yksityinen',
  },
  OrderBy: {
    en: 'Order by',
    es: 'Ordenar por',
    fr: 'Trier par',
    de: 'Sortieren nach',
    pt: 'Ordenar por',
    cs: 'Seřadit podle',
    fi: 'Järjestä',
  },
  Password: {
    en: 'Password',
    es: 'Contraseña',
    fr: 'Mot de passe',
    de: 'Passwort',
    pt: 'Senha',
    cs: 'Heslo',
    fi: 'Salasana',
  },
  PasswordsDoNotMatch: {
    en: 'Passwords do not match',
    es: 'Las contraseñas no coinciden',
    fr: 'Les mots de passe ne correspondent pas',
    de: 'Passwörter stimmen nicht überein',
    pt: 'As senhas não coincidem',
    cs: 'Hesla se neshodují',
    fi: 'Salasanat eivät täsmää',
  },
  EditLanguagePreference: {
    en: 'Edit language preference',
    es: 'Editar preferencia de idioma',
    fr: 'Modifier les préférences linguistiques',
    de: 'Spracheinstellung bearbeiten',
    pt: 'Editar preferência de idioma',
    cs: 'Upravit jazykové nastavení',
    fi: 'Muokkaa kieliasetuksia',
  },
  EditPreferredNickname: {
    en: 'Edit preferred nickname',
    es: 'Editar apodo preferido',
    fr: 'Modifier le surnom préféré',
    de: 'Bevorzugten Spitznamen bearbeiten',
    pt: 'Editar apelido preferido',
    cs: 'Upravit preferovanou přezdívku',
    fi: 'Muokkaa nimimerkkiä',
  },
  EditPassword: {
    en: 'Edit password',
    es: 'Editar contraseña',
    fr: 'Modifier le mot de passe',
    de: 'Passwort bearbeiten',
    pt: 'Editar senha',
    cs: 'Upravit heslo',
    fi: 'Muokkaa salasanaa',
  },
  EditEmail: {
    en: 'Edit email',
    es: 'Editar correo electrónico',
    fr: "Modifier l'adresse e-mail",
    de: 'E-Mail bearbeiten',
    pt: 'Editar email',
    cs: 'Upravit e-mail',
    fi: 'Muokkaa sähköpostia',
  },
  SendsAnEmailToTheNewAddressForVerification: {
    en: 'Sends an email to the new address for verification',
    es: 'Envía un correo electrónico a la nueva dirección para su verificación',
    fr: 'Envoie un e-mail à la nouvelle adresse pour vérification',
    de: 'Sendet eine E-Mail an die neue Adresse zur Überprüfung',
    pt: 'Envia um e-mail para o novo endereço para verificação',
    cs: 'Odešle e-mail na novou adresu k ověření',
    fi: 'Lähettää varmennuslinkin uuteen sähköpostiin',
  },
  CurrentEmail: {
    en: 'Current email',
    es: 'Correo electrónico actual',
    fr: 'Email actuel',
    de: 'Aktuelle E-Mail',
    pt: 'Email atual',
    cs: 'Aktuální e-mail',
    fi: 'Nykyinen sähköposti',
  },
  EditUserSettings: {
    en: 'Here you can edit your user settings and delete your account',
    es: 'Aquí puede editar su configuración de usuario y eliminar su cuenta',
    fr: 'Vous pouvez modifier vos paramètres utilisateur ici et supprimer votre compte',
    de: 'Hier können Sie Ihre Benutzereinstellungen bearbeiten und Ihr Konto löschen',
    pt: 'Aqui você pode editar suas configurações de usuário e excluir sua conta',
    cs: 'Zde můžete upravit svá nastavení uživatele a smazat svůj účet',
    fi: 'Täällä voit muokata käyttäjäasetuksiasi ja poistaa tilisi',
  },
  AreYouSureYouWantToDelete: {
    en: 'Are you sure you want to delete',
    es: '¿Estás seguro de que quieres borrar',
    fr: 'Êtes-vous sûr de vouloir supprimer',
    de: 'Möchten Sie wirklich löschen',
    pt: 'Tem certeza de que deseja excluir',
    cs: 'Opravdu chcete smazat',
    fi: 'Haluatko varmasti poistaa',
  },
  YouWillLoseAllTheDataAssociatedWithIt: {
    en: 'You will lose all the data associated with the account. This action cannot be undone!',
    es: 'Perderá todos los datos asociados con la cuenta. ¡Esta acción no se puede deshacer!',
    fr: 'Vous perdrez toutes les données associées au compte. Cette action ne peut pas être annulée!',
    de: 'Sie verlieren alle mit dem Konto verbundenen Daten. Diese Aktion kann nicht rückgängig gemacht werden!',
    pt: 'Você perderá todos os dados associados à conta. Esta ação não pode ser desfeita!',
    cs: 'Ztratíte všechna data spojená s účtem. Tuto akci nelze vrátit!',
    fi: 'Menetät kaikki tilin liittyvät tiedot. Tätä toimintoa ei voi peruuttaa!',
  },
  AccountDeleted: {
    en: 'Account deleted',
    es: 'Cuenta eliminada',
    fr: 'Compte supprimé',
    de: 'Konto gelöscht',
    pt: 'Conta excluída',
    cs: 'Účet smazán',
    fi: 'Tili poistettu',
  },
  DeleteAccount: {
    en: 'Delete account',
    es: 'Borrar cuenta',
    fr: 'Supprimer le compte',
    de: 'Konto löschen',
    pt: 'Excluir conta',
    cs: 'Smazat účet',
    fi: 'Poista tili',
  },
  RememberToLogOutAndLogBackInWithYourNewEmailOnceConfirmed: {
    en: 'Remember to log out and log back in with your new email once confirmed',
    es: 'Recuerde cerrar sesión e iniciar sesión nuevamente con su nuevo correo electrónico una vez confirmado',
    fr: 'N’oubliez pas de vous déconnecter puis de vous reconnecter avec votre nouvel e-mail une fois confirmé',
    de: 'Denken Sie daran, sich abzumelden und sich nach der Bestätigung mit Ihrer neuen E-Mail-Adresse erneut anzumelden',
    pt: 'Lembre-se de sair e entrar novamente com seu novo e-mail assim que for confirmado',
    cs: 'Nezapomeňte se odhlásit a po potvrzení se znovu přihlásit pomocí svého nového e-mailu',
    fi: 'Muista kirjautua ulos ja takaisin sisään uudella sähköpostiosoitteellasi, kun se on vahvistettu',
  },
  PendingVerification: {
    en: 'Pending verification',
    es: 'Verificación pendiente',
    fr: 'Vérification en attente',
    de: 'Ausstehende Überprüfung',
    pt: 'Verificação pendente',
    cs: 'Čekající ověření',
    fi: 'Odottaa vahvistusta',
  },
  PerPage: {
    en: 'per page',
    es: 'por página',
    fr: 'par page',
    de: 'pro Seite',
    pt: 'por página',
    cs: 'na stránku',
    fi: 'sivua kohden',
  },
  PleaseGiveValidEmail: {
    en: 'Please give valid email',
    es: 'Por favor, dé un correo electrónico válido',
    fr: 'Veuillez donner un email valide',
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    pt: 'Por favor, dê um email válido',
    cs: 'Zadejte platný e-mail',
    fi: 'Anna kelvollinen sähköpostiosoite',
  },
  PleaseLogin: {
    en: 'Please login',
    es: 'Por favor inicie sesión',
    fr: 'Veuillez vous connecter',
    de: 'Bitte melden Sie sich an',
    pt: 'Por favor, faça login',
    cs: 'Prosím přihlaste se',
    fi: 'Pyydämme kirjautumaan sisään',
  },
  PleaseLoginToVerifyJoke: {
    en: 'Please login with an admin account to verify this joke',
    es: 'Inicie sesión con una cuenta de administrador para verificar esta broma',
    fr: 'Veuillez vous connecter avec un compte administrateur pour vérifier cette blague',
    de: 'Bitte melden Sie sich mit einem Administratorkonto an, um diesen Witz zu überprüfen',
    pt: 'Faça login com uma conta de administrador para verificar esta piada',
    cs: 'Přihlaste se prosím pomocí účtu správce, abyste mohli tento vtip ověřit',
    fi: 'Kirjaudu sisään ylläpitäjätilillä vahvistaaksesi tämän vitsin',
  },
  Verify: {
    en: 'Verify',
    es: 'Verificar',
    fr: 'Vérifier',
    de: 'Überprüfen',
    pt: 'Verificar',
    cs: 'Ověřit',
    fi: 'Vahvista',
  },
  PleaseSelectAnOption: {
    en: 'Please select an option',
    es: 'Por favor seleccione una opción',
    fr: 'Veuillez sélectionner une option',
    de: 'Bitte wählen Sie eine Option',
    pt: 'Por favor selecione uma opção',
    cs: 'Vyberte prosím možnost',
    fi: 'Valitse vaihtoehto',
  },
  PleaseUseGoodTasteWhenChoosingYourNickname: {
    en: 'Please use good taste when choosing your nickname',
    es: 'Por favor, use buen gusto al elegir su apodo',
    fr: 'Veuillez utiliser bon goût lors du choix de votre surnom',
    de: 'Bitte verwenden Sie guten Geschmack bei der Auswahl Ihres Spitznamens',
    pt: 'Por favor, use bom gosto ao escolher seu apelido',
    cs: 'Použijte prosím dobrý vkus při výběru přezdívky',
    fi: 'Pyydän noudattamaan hyvää makua nimimerkin valitsemisessa',
  },
  TheDataController: {
    en: 'The data controller',
    es: 'El controlador de datos',
    fr: 'Le responsable du traitement',
    de: 'Der Datenverantwortliche',
    pt: 'O controlador de dados',
    cs: 'Správce údajů',
    fi: 'Rekisterinpitäjä',
  },
  TheDataControllerIs: {
    en: 'The data controller for your personal information is Jenniina Laine.',
    es: 'El controlador de datos de su información personal es Jenniina Laine.',
    fr: 'Le responsable du traitement de vos informations personnelles est Jenniina Laine.',
    de: 'Der Datenverantwortliche für Ihre persönlichen Daten ist Jenniina Laine.',
    pt: 'O controlador de dados de suas informações pessoais é Jenniina Laine.',
    cs: 'Správce vašich osobních údajů je Jenniina Laine.',
    fi: 'Henkilötietojesi rekisterinpitäjä on Jenniina Laine.',
  },
  OtherPersonalDataIsNotCollected: {
    en: 'Other personal data is not collected unless you provide it voluntarily (e.g. via contact forms).',
    es: 'No se recopilan otros datos personales a menos que los proporcione voluntariamente (por ejemplo, a través de formularios de contacto).',
    fr: "D'autres données personnelles ne sont pas collectées à moins que vous ne les fournissiez volontairement (par exemple via des formulaires de contact).",
    de: 'Andere personenbezogene Daten werden nicht gesammelt, es sei denn, Sie stellen sie freiwillig zur Verfügung (z. B. über Kontaktformulare).',
    pt: 'Outros dados pessoais não são coletados, a menos que você os forneça voluntariamente (por exemplo, por meio de formulários de contato).',
    cs: 'Jiné osobní údaje nejsou shromažďovány, pokud je neposkytnete dobrovolně (např. prostřednictvím kontaktních formulářů).',
    fi: 'Muita henkilötietoja ei kerätä, ellei niitä anneta vapaaehtoisesti (esim. yhteydenottolomakkeiden kautta).',
  },
  LegalBasisForProcessing: {
    en: 'Legal Basis for Processing',
    es: 'Base legal para el procesamiento',
    fr: 'Base légale du traitement',
    de: 'Rechtsgrundlage für die Verarbeitung',
    pt: 'Base legal para o processamento',
    cs: 'Právní základ pro zpracování',
    fi: 'Oikeudellinen peruste käsittelylle',
  },
  WeProcessYourPersonalDataOnBasisOf: {
    en: 'We process your personal data based on:',
    es: 'Procesamos sus datos personales en función de:',
    fr: 'Nous traitons vos données personnelles sur la base de:',
    de: 'Wir verarbeiten Ihre personenbezogenen Daten auf der Grundlage von:',
    pt: 'Processamos seus dados pessoais com base em:',
    cs: 'Zpracováváme vaše osobní údaje na základě:',
    fi: 'Käsittelemme henkilötietojasi seuraavien perusteiden mukaan:',
  },
  ContractToProvideServices: {
    en: 'Contract: for us to provide the service you sign up for.',
    es: 'Contrato: para que podamos brindarle el servicio al que se inscribe.',
    fr: 'Contrat : pour que nous puissions fournir le service auquel vous vous inscrivez.',
    de: 'Vertrag: damit wir den Dienst bereitstellen können, für den Sie sich anmelden.',
    pt: 'Contrato: para que possamos fornecer o serviço para o qual você se inscreve.',
    cs: 'Smlouva: abychom mohli poskytnout službu, na kterou se přihlašujete.',
    fi: 'Sopimus: jotta voimme tarjota sinulle palvelua, johon rekisteröidyt.',
  },
  DataCollectionAndStorage: {
    en: 'Data Collection and Storage',
    es: 'Recolección y almacenamiento de datos',
    fr: 'Collecte et stockage de données',
    de: 'Datenerfassung und Speicherung',
    pt: 'Coleta e armazenamento de dados',
    cs: 'Sběr a ukládání dat',
    fi: 'Tietojen kerääminen ja tallentaminen',
  },
  WeCollectAndStoreTheEmailAddress: {
    en: 'We collect and store the email address you provide as your username.',
    es: 'Recopilamos y almacenamos la dirección de correo electrónico que proporciona como su nombre de usuario.',
    fr: 'Nous collectons et stockons l adresse e-mail que vous fournissez en tant que nom d utilisateur.',
    de: 'Wir erfassen und speichern die E-Mail-Adresse, die Sie als Benutzernamen angeben.',
    pt: 'Coletamos e armazenamos o endereço de e-mail que você fornece como seu nome de usuário.',
    cs: 'Sbíráme a ukládáme e-mailovou adresu, kterou poskytnete jako své uživatelské jméno.',
    fi: 'Keräämme ja tallennamme sähköpostiosoitteen, jonka annat käyttäjänimesi.',
  },
  YourPasswordIsSecurelyHashed: {
    en: 'Your password is securely hashed and stored in our database. We do not store your password in plain text.',
    es: 'Su contraseña se cifra de forma segura y se almacena en nuestra base de datos. No almacenamos su contraseña en texto sin formato.',
    fr: 'Votre mot de passe est crypté de manière sécurisée et stocké dans notre base de données. Nous ne stockons pas votre mot de passe en texte clair.',
    de: 'Ihr Passwort wird sicher gehasht und in unserer Datenbank gespeichert. Wir speichern Ihr Passwort nicht im Klartext.',
    pt: 'Sua senha é criptografada com segurança e armazenada em nosso banco de dados. Não armazenamos sua senha em texto simples.',
    cs: 'Vaše heslo je bezpečně zahashováno a uloženo v naší databázi. Heslo neukládáme v čistém textu.',
    fi: 'Salasanasi on turvallisesti tiivistetty ja tallennettu tietokantaamme. Emme tallenna salasanaasi selkokielisenä.',
  },
  DataProtection: {
    en: 'Data Protection',
    es: 'Protección de datos',
    fr: 'Protection des données',
    de: 'Datenschutz',
    pt: 'Proteção de dados',
    cs: 'Ochrana dat',
    fi: 'Tietosuoja',
  },
  WeUseIndustryStandardSecurityMeasures: {
    en: 'Industry-standard measures (encryption, hashing, secure protocols) are used.',
    es: 'Se utilizan medidas estándar de la industria (cifrado, hashing, protocolos seguros).',
    fr: "Des mesures standard de l'industrie (cryptage, hachage, protocoles sécurisés) sont utilisées.",
    de: 'Es werden branchenübliche Sicherheitsmaßnahmen (Verschlüsselung, Hashing, sichere Protokolle) verwendet.',
    pt: 'São utilizadas medidas padrão do setor (criptografia, hashing, protocolos seguros).',
    cs: 'Používají se průmyslové standardní opatření (šifrování, hashování, zabezpečené protokoly).',
    fi: 'Käytetään teollisuuden standardin mukaisia toimenpiteitä (salaus, hashing, turvalliset protokollat).',
  },
  AccessToYourDataIsRestricted: {
    en: 'Access to your data is restricted to authorized personnel only.',
    es: 'El acceso a sus datos está restringido solo al personal autorizado.',
    fr: 'L accès à vos données est limité au personnel autorisé uniquement.',
    de: 'Der Zugriff auf Ihre Daten ist nur für autorisiertes Personal beschränkt.',
    pt: 'O acesso aos seus dados é restrito apenas ao pessoal autorizado.',
    cs: 'Přístup k vašim datům je omezen pouze na autorizovaný personál.',
    fi: 'Pääsy tietoihisi on rajoitettu vain valtuutettuun henkilöstöön.',
  },
  UserResponsibilities: {
    en: 'User Responsibilities',
    es: 'Responsabilidades del usuario',
    fr: 'Responsabilités de l utilisateur',
    de: 'Benutzerpflichten',
    pt: 'Responsabilidades do usuário',
    cs: 'Uživatelské povinnosti',
    fi: 'Käyttäjän vastuut',
  },
  PleaseChooseAStrongAndUniquePassword: {
    en: 'Please choose a strong and unique password to enhance your account security.',
    es: 'Por favor, elija una contraseña fuerte y única para mejorar la seguridad de su cuenta.',
    fr: 'Veuillez choisir un mot de passe fort et unique pour renforcer la sécurité de votre compte.',
    de: 'Bitte wählen Sie ein starkes und einzigartiges Passwort, um die Sicherheit Ihres Kontos zu erhöhen.',
    pt: 'Por favor, escolha uma senha forte e única para aumentar a segurança da sua conta.',
    cs: 'Vyberte prosím silné a jedinečné heslo, abyste zvýšili bezpečnost svého účtu.',
    fi: 'Valitse vahva ja uniikki salasana lisätäksesi tilisi turvallisuutta.',
  },
  DoNotShareYourPasswordWithAnyone: {
    en: 'Do not share your password with anyone.',
    es: 'No comparta su contraseña con nadie.',
    fr: 'Ne partagez pas votre mot de passe avec qui que ce soit.',
    de: 'Teilen Sie Ihr Passwort nicht mit anderen.',
    pt: 'Não compartilhe sua senha com ninguém.',
    cs: 'Nesdílejte své heslo s nikým.',
    fi: 'Älä jaa salasanaasi kenenkään kanssa.',
  },
  YourRights: {
    en: 'Your Rights',
    es: 'Tus derechos',
    fr: 'Vos droits',
    de: 'Deine Rechte',
    pt: 'Seus direitos',
    cs: 'Vaše práva',
    fi: 'Oikeutesi',
  },
  YouHaveTheRightToAccessModifyOrDelete: {
    en: 'You have the right to access, modify, or delete your personal information stored in our system.',
    es: 'Tiene derecho a acceder, modificar o eliminar su información personal almacenada en nuestro sistema.',
    fr: 'Vous avez le droit d accéder, de modifier ou de supprimer vos informations personnelles stockées dans notre système.',
    de: 'Sie haben das Recht, auf Ihre in unserem System gespeicherten persönlichen Informationen zuzugreifen, sie zu ändern oder zu löschen.',
    pt: 'Você tem o direito de acessar, modificar ou excluir suas informações pessoais armazenadas em nosso sistema.',
    cs: 'Máte právo přistupovat, měnit nebo mazat své osobní informace uložené v našem systému.',
    fi: 'Sinulla on oikeus käyttää, muokata tai poistaa henkilökohtaiset tietosi, jotka on tallennettu järjestelmäämme.',
  },
  IfYouHaveAnyConcernsAboutYourDataSecurity: {
    en: 'If you have any concerns about your data security, please contact me',
    es: 'Si tiene alguna preocupación sobre la seguridad de sus datos, por favor contácteme',
    fr: 'Si vous avez des préoccupations concernant la sécurité de vos données, veuillez me contacter',
    de: 'Wenn Sie Bedenken hinsichtlich der Sicherheit Ihrer Daten haben, kontaktieren Sie mich bitte',
    pt: 'Se você tiver alguma preocupação sobre a segurança de seus dados, entre em contato comigo',
    cs: 'Pokud máte jakékoli obavy ohledně zabezpečení svých dat, kontaktujte mě',
    fi: 'Jos sinulla on huolenaiheita tietoturvasi suhteen, ota yhteyttä',
  },
  ChangesToThisDisclaimer: {
    en: 'Changes to This Disclaimer',
    es: 'Cambios a este descargo de responsabilidad',
    fr: 'Changements à cet avis de non-responsabilité',
    de: 'Änderungen an diesem Haftungsausschluss',
    pt: 'Alterações a este aviso de isenção',
    cs: 'Změny tohoto prohlášení',
    fi: 'Muutokset tähän vastuuvapauslausekkeeseen',
  },
  WeMayUpdateThisDisclaimerFromTimeToTime: {
    en: 'We may update this disclaimer from time to time. We will notify you of any significant changes by posting the new disclaimer on our website.',
    es: 'Podemos actualizar este descargo de responsabilidad de vez en cuando. Le notificaremos cualquier cambio significativo publicando el nuevo descargo de responsabilidad en nuestro sitio web.',
    fr: 'Nous pouvons mettre à jour cet avis de non-responsabilité de temps à autre. Nous vous informerons de tout changement significatif en publiant le nouvel avis de non-responsabilité sur notre site Web.',
    de: 'Wir können diesen Haftungsausschluss von Zeit zu Zeit aktualisieren. Wir informieren Sie über wesentliche Änderungen, indem wir den neuen Haftungsausschluss auf unserer Website veröffentlichen.',
    pt: 'Podemos atualizar este aviso de isenção de responsabilidade de tempos em tempos. Notificaremos você sobre quaisquer alterações significativas, publicando o novo aviso de isenção em nosso site.',
    cs: 'Můžeme aktualizovat toto prohlášení z času na čas. O jakýchkoli významných změnách vás budeme informovat zveřejněním nového prohlášení na našich webových stránkách.',
    fi: 'Voimme päivittää tätä vastuuvapauslauseketta aika ajoin. Ilmoitamme sinulle merkittävistä muutoksista julkaisemalla uuden vastuuvapauslausekkeen verkkosivustollamme.',
  },
  ByUsingOurService: {
    en: 'By using our service, you agree to the collection and use of your information in accordance with this disclaimer.',
    es: 'Al utilizar nuestro servicio, acepta la recopilación y el uso de su información de acuerdo con este descargo de responsabilidad.',
    fr: 'En utilisant notre service, vous acceptez la collecte et l utilisation de vos informations conformément à cet avis de non-responsabilité.',
    de: 'Durch die Nutzung unseres Dienstes stimmen Sie der Erfassung und Verwendung Ihrer Informationen gemäß diesem Haftungsausschluss zu.',
    pt: 'Ao usar nosso serviço, você concorda com a coleta e o uso de suas informações de acordo com este aviso de isenção de responsabilidade.',
    cs: 'Používáním našich služeb souhlasíte se sběrem a použitím vašich informací v souladu s tímto prohlášením.',
    fi: 'Käyttämällä palveluamme hyväksyt tietojesi keräämisen ja käytön tämän vastuuvapauslausekkeen mukaisesti.',
  },
  LastUpdated: {
    en: 'Last updated',
    es: 'Última actualización',
    fr: 'Dernière mise à jour',
    de: 'Zuletzt aktualisiert',
    pt: 'Última atualização',
    cs: 'Naposledy aktualizováno',
    fi: 'Viimeksi päivitetty',
  },
  Contact: {
    en: 'Contact',
    es: 'Contacto',
    fr: 'Contact',
    de: 'Kontakt',
    pt: 'Contato',
    cs: 'Kontakt',
    fi: 'Yhteys',
  },
  Private: {
    en: 'Private',
    es: 'Privado',
    fr: 'Privé',
    de: 'Privat',
    pt: 'Privado',
    cs: 'Soukromý',
    fi: 'Yksityinen',
  },
  Public: {
    en: 'Public',
    es: 'Público',
    fr: 'Public',
    de: 'Öffentlichkeit',
    pt: 'Público',
    cs: 'Veřejnost',
    fi: 'Julkinen',
  },
  Publish: {
    en: 'Publish',
    es: 'Publicar',
    fr: 'Publier',
    de: 'Veröffentlichen',
    pt: 'Publicar',
    cs: 'Publikovat',
    fi: 'Julkaise',
  },
  PublishAnonymously: {
    en: 'Publish anonymously',
    es: 'Publicar anónimamente',
    fr: 'Publier anonymement',
    de: 'Anonym veröffentlichen',
    pt: 'Publicar anonimamente',
    cs: 'Publikovat anonymně',
    fi: 'Julkaise nimettömänä',
  },
  PublishWithNickname: {
    en: 'Publish with nickname',
    es: 'Publicar con apodo',
    fr: 'Publier avec un pseudonyme',
    de: 'Mit Spitznamen veröffentlichen',
    pt: 'Publicar com apelido',
    cs: 'Publikovat s přezdívkou',
    fi: 'Julkaise nimimerkillä',
  },
  Random: {
    en: 'Random',
    es: 'Aleatorio',
    fr: 'Aléatoire',
    de: 'Zufällig',
    pt: 'Aleatório',
    cs: 'Náhodný',
    fi: 'Satunnainen',
  },
  Register: {
    en: 'Register',
    es: 'Registrarse',
    fr: "S'inscrire",
    de: 'Registrieren',
    pt: 'Registo',
    cs: 'Registrovat',
    fi: 'Rekisteröidy',
  },
  RegisterAndLoginToUse: {
    en: 'Register and log in to save your favorite jokes to a Mongo-DB database',
    es: 'Regístrese e inicie sesión para guardar sus chistes favoritos en una base de datos Mongo-DB',
    fr: 'Inscrivez-vous et connectez-vous pour enregistrer vos blagues préférées dans une base de données Mongo-DB',
    de: 'Registrieren Sie sich und melden Sie sich an, um Ihre Lieblingswitze in einer Mongo-DB-Datenbank zu speichern',
    pt: 'Registre-se e faça login para salvar suas piadas favoritas em um banco de dados Mongo-DB',
    cs: 'Zaregistrujte se a přihlaste se, abyste si mohli uložit své oblíbené vtipy do databáze Mongo-DB',
    fi: 'Rekisteröidy ja kirjaudu sisään tallentaaksesi suosikkivitsisi Mongo-DB-tietokantaan',
  },
  RegistrationSuccesful: {
    en: 'Registration successful',
    es: 'Registro exitoso',
    fr: 'Inscription réussie',
    de: 'Registrierung erfolgreich',
    pt: 'Registro bem sucedido',
    cs: 'Registrace úspěšná',
    fi: 'Rekisteröinti onnistui',
  },
  Remove: {
    en: 'Remove',
    es: 'Eliminar',
    fr: 'Supprimer',
    de: 'Entfernen',
    pt: 'Remover',
    cs: 'Odstranit',
    fi: 'Poista',
  },
  ReportErrorToAdmin: {
    en: 'Report error to admin',
    es: 'Informar error al administrador',
    fr: "Signaler une erreur à l'administrateur",
    de: 'Fehler an Admin melden',
    pt: 'Relatar erro ao administrador',
    cs: 'Nahlásit chybu správci',
    fi: 'Ilmoita virheestä ylläpidolle',
  },
  Reset: {
    en: 'Reset',
    es: 'Reiniciar',
    fr: 'Réinitialiser',
    de: 'Zurücksetzen',
    pt: 'Redefinir',
    cs: 'Resetovat',
    fi: 'Nollaa',
  },
  Restore: {
    en: 'Restore',
    es: 'Restaurar',
    fr: 'Restaurer',
    de: 'Wiederherstellen',
    pt: 'Restaurar',
    cs: 'Obnovit',
    fi: 'Palauta',
  },
  SafeTitle: {
    en: 'Safe',
    es: 'Seguro',
    fr: 'Sûr',
    de: 'Sicher',
    pt: 'Seguro',
    cs: 'Bezpečné',
    fi: 'Turvallinen',
  },
  SafemodeTitle: {
    en: 'Safe Mode',
    es: 'Modo seguro',
    fr: 'Mode sécurisé',
    de: 'Sicherer Modus',
    pt: 'Modo seguro',
    cs: 'Bezpečný režim',
    fi: 'Turvallinen',
  },
  SaveJoke: {
    en: 'Save Joke',
    es: 'Guardar chiste',
    fr: 'Enregistrer la blague',
    de: 'Witz speichern',
    pt: 'Salvar piada',
    cs: 'Uložit vtip',
    fi: 'Tallenna vitsi',
  },
  SavedBy: {
    en: 'Saved by',
    es: 'Guardado por',
    fr: 'Sauvegardé par',
    de: 'Gespeichert von',
    pt: 'Salvo por',
    cs: 'Uloženo',
    fi: 'Tallentanut',
  },
  SavedJoke: {
    en: 'Saved joke',
    es: 'Chiste guardado',
    fr: 'Blague enregistrée',
    de: 'Gespeicherter Witz',
    pt: 'Piada salva',
    cs: 'Uložený vtip',
    fi: 'Vitsi tallennettu',
  },
  Saving: {
    en: 'Saving...',
    es: 'Guardando...',
    fr: 'Sauvegarde...',
    de: 'Speichern...',
    pt: 'Salvando...',
    cs: 'Ukládání...',
    fi: 'Tallennetaan...',
  },
  ScrollToTheTop: {
    en: 'Scroll to the top',
    es: 'Desplázate hacia arriba',
    fr: 'Faites défiler vers le haut',
    de: 'Nach oben scrollen',
    pt: 'Role para o topo',
    cs: 'Posuňte se nahoru',
    fi: 'Vieritä takaisin ylös',
  },
  Search: {
    en: 'Search',
    es: 'Buscar',
    fr: 'Chercher',
    de: 'Suche',
    pt: 'Pesquisar',
    cs: 'Vyhledávání',
    fi: 'Hae',
  },
  SearchByKeyword: {
    en: 'Search by keyword',
    es: 'Buscar por palabra clave',
    fr: 'Recherche par mot-clé',
    de: 'Suche nach Schlüsselwort',
    pt: 'Pesquisar por palavra-chave',
    cs: 'Hledat podle klíčového slova',
    fi: 'Hae avainsanalla',
  },
  SeeLocalJokes: {
    en: 'See local jokes',
    es: 'Ver chistes locales',
    fr: 'Voir les blagues locales',
    de: 'Lokale Witze anzeigen',
    pt: 'Ver piadas locais',
    cs: 'Zobrazit místní vtipy',
    fi: 'Katso paikalliset vitsit',
  },
  SelectACategory: {
    en: 'Select a category',
    es: 'Seleccione una categoría',
    fr: 'Sélectionnez une catégorie',
    de: 'Wählen Sie eine Kategorie',
    pt: 'Selecione uma categoria',
    cs: 'Vyberte kategorii',
    fi: 'Valitse kategoria',
  },
  SelectAnOption: {
    en: 'Select an option',
    es: 'Seleccione una opción',
    fr: 'Sélectionnez une option',
    de: 'Wählen Sie eine Option',
    pt: 'Selecione uma opção',
    cs: 'Vyberte možnost',
    fi: 'Valitse',
  },
  SelectCategory: {
    en: 'Select category',
    es: 'Seleccionar categoría',
    fr: 'Sélectionnez une catégorie',
    de: 'Kategorie auswählen',
    pt: 'Selecione a categoria',
    cs: 'Vyberte kategorii',
    fi: 'Valitse kategoria',
  },
  SelectLanguage: {
    en: 'Select Language',
    es: 'Seleccionar idioma',
    fr: 'Sélectionnez la langue',
    de: 'Sprache auswählen',
    pt: 'Selecione o idioma',
    cs: 'Vyberte jazyk',
    fi: 'Valitse kieli',
  },
  Send: {
    en: 'Send',
    es: 'Enviar',
    fr: 'Envoyer',
    de: 'Senden',
    pt: 'Enviar',
    cs: 'Poslat',
    fi: 'Lähetä',
  },
  SendResetLink: {
    en: 'Send Reset Link',
    es: 'Enviar enlace de restablecimiento',
    fr: 'Envoyer le lien de réinitialisation',
    de: 'Link zum Zurücksetzen senden',
    pt: 'Enviar link de redefinição',
    cs: 'Odeslat odkaz na obnovení',
    fi: 'Lähetä nollauslinkki',
  },
  SendingEmail: {
    en: 'Sending email...',
    es: 'Enviando correo electrónico...',
    fr: "Envoi d'email...",
    de: 'E-Mail senden...',
    pt: 'Enviando email...',
    cs: 'Odesílání e-mailu...',
    fi: 'Lähetetään sähköpostia...',
  },
  Single: {
    en: 'Single',
    es: 'Soltero',
    fr: 'Célibataire',
    de: 'Single',
    pt: 'Solteiro',
    cs: 'Single',
    fi: 'Yksiosainen',
  },
  Either: {
    en: 'Either',
    es: 'Cualquiera',
    fr: 'Les deux',
    de: 'Beide',
    pt: 'Qualquer um',
    cs: 'Obojí',
    fi: 'Kumpi vain',
  },
  SkipToJokeSearch: {
    en: 'Skip to joke search',
    es: 'Saltar a la búsqueda de bromas',
    fr: 'Passer à la recherche de blagues',
    de: 'Zur Witzsuche springen',
    pt: 'Pular para a pesquisa de piadas',
    cs: 'Přejít na vyhledávání vtipů',
    fi: 'Siirry vitsihakuun',
  },
  SkipToSavedJokes: {
    en: 'Skip to saved jokes',
    es: 'Saltar a las bromas guardadas',
    fr: 'Passer aux blagues enregistrées',
    de: 'Zu gespeicherten Witzen springen',
    pt: 'Pular para piadas salvas',
    cs: 'Přejít na uložené vtipy',
    fi: 'Siirry tallennettuihin vitseihin',
  },
  SubmitAJoke: {
    en: 'Submit a Joke',
    es: 'Enviar una broma',
    fr: 'Soumettre une blague',
    de: 'Einen Witz einreichen',
    pt: 'Enviar uma piada',
    cs: 'Odeslat vtip',
    fi: 'Kirjoita oma vitsi',
  },
  SubmitAJokeTo: {
    en: 'Submit a joke to ',
    es: 'Enviar una broma a ',
    fr: 'Soumettre une blague à ',
    de: 'Einen Witz senden an ',
    pt: 'Enviar uma piada para ',
    cs: 'Odeslat vtip do ',
    fi: 'Lähetä vitsi kohteeseen ',
  },
  TheComediansCompanion: {
    en: "The Comedian's Companion",
    es: 'El Compañero del Comediante',
    fr: 'Le Compagnon du Comédien',
    de: 'Der Begleiter des Komikers',
    pt: 'O Companheiro do Comediante',
    cs: 'Společník komika',
    fi: 'Koomikon Kumppani',
  },
  ThisFieldIsRequired: {
    en: 'This field is required',
    es: 'Este campo es obligatorio',
    fr: 'Ce champ est obligatoire',
    de: 'Dieses Feld ist erforderlich',
    pt: 'Este campo é obrigatório',
    cs: 'Toto pole je povinné',
    fi: 'Tämä kenttä on pakollinen',
  },
  ThisJokeIsAlreadyBlacklisted: {
    en: 'This joke is already blacklisted.',
    es: 'Esta broma ya está en la lista negra.',
    fr: 'Cette blague est déjà sur liste noire.',
    de: 'Dieser Witz ist bereits auf der schwarzen Liste.',
    pt: 'Esta piada já está na lista negra.',
    cs: 'Tento vtip je již na černé listině.',
    fi: 'Tämä vitsi on jo piilotettu.',
  },
  ThisMayTakeUpToAMinute: {
    en: 'This may take up to a minute',
    es: 'Esto puede tardar hasta un minuto',
    fr: "Cela peut prendre jusqu'à une minute",
    de: 'Dies kann bis zu einer Minute dauern',
    pt: 'Isso pode levar até um minuto',
    cs: 'To může trvat až minutu',
    fi: 'Tämä voi kestää jopa minuutin',
  },
  TwoPart: {
    en: 'Two-Part',
    es: 'Dos partes',
    fr: 'Deux parties',
    de: 'Zweiteilig',
    pt: 'Duas partes',
    cs: 'Dvoudílný',
    fi: 'Kaksiosainen',
  },
  UnsafeTitle: {
    en: 'Unsafe',
    es: 'Inseguro',
    fr: 'Pas sûr',
    de: 'Unsicher',
    pt: 'Inseguro',
    cs: 'Nebezpečné',
    fi: 'Turvaton',
  },
  UserSubmittedJokes: {
    en: 'User submitted jokes',
    es: 'Chistes enviados por el usuario',
    fr: 'Blagues soumises par les utilisateurs',
    de: 'Vom Benutzer eingereichte Witze',
    pt: 'Piadas enviadas pelo usuário',
    cs: 'Vtipy zaslané uživatelem',
    fi: 'Käyttäjien vitsit',
  },
  WouldYouLikeToSaveTheJoke: {
    en: 'Would you like to save the joke?',
    es: '¿Te gustaría guardar la broma?',
    fr: 'Souhaitez-vous enregistrer la blague?',
    de: 'Möchten Sie den Witz speichern?',
    pt: 'Você gostaria de salvar a piada?',
    cs: 'Chcete uložit vtip?',
    fi: 'Haluatko tallentaa vitsin?',
  },
  YourSavedJokes: {
    en: 'Your Saved Jokes',
    es: 'Tus chistes guardados',
    fr: 'Vos blagues enregistrées',
    de: 'Ihre gespeicherten Witze',
    pt: 'Suas piadas salvas',
    cs: 'Vaše uložené vtipy',
    fi: 'Tallentamasi vitsit',
  },
  UnverifiedJokes: {
    en: 'Unverified Jokes',
    es: 'Bromas no verificadas',
    fr: 'Blagues non vérifiées',
    de: 'Nicht verifizierte Witze',
    pt: 'Piadas não verificadas',
    cs: 'Neověřené vtipy',
    fi: 'Vahvistamattomat vitsit',
  },
  NoUnverifiedJokes: {
    en: 'No unverified jokes',
    es: 'No hay bromas sin verificar',
    fr: 'Aucune blague non vérifiée',
    de: 'Keine nicht verifizierten Witze',
    pt: 'Nenhuma piada não verificada',
    cs: 'Žádné neověřené vtipy',
    fi: 'Ei vahvistamattomia vitsejä',
  },
  Unavailable: {
    en: 'Unavailable',
    es: 'No disponible',
    fr: 'Indisponible',
    de: 'Nicht verfügbar',
    pt: 'Indisponível',
    cs: 'Nedostupné',
    fi: 'Ei käytettävissä',
  },
  UnavailableForTestUser: {
    en: 'Unavailable for the test user account',
    es: 'No disponible para la cuenta de usuario de prueba',
    fr: 'Indisponible pour le compte utilisateur de test',
    de: 'Für das Testbenutzerkonto nicht verfügbar',
    pt: 'Indisponível para a conta de usuário de teste',
    cs: 'Není k dispozici pro testovací uživatelský účet',
    fi: 'Ei saatavilla testikäyttäjätilille',
  },
  AlreadyOnFirstPage: {
    en: 'Already on the first page',
    es: 'Ya estás en la primera página',
    fr: 'Déjà sur la première page',
    de: 'Bereits auf der ersten Seite',
    pt: 'Já está na primeira página',
    cs: 'Již jste na první stránce',
    fi: 'Olet jo ensimmäisellä sivulla',
  },
  AlreadyOnLastPage: {
    en: 'Already on the last page',
    es: 'Ya estás en la última página',
    fr: 'Déjà sur la dernière page',
    de: 'Bereits auf der letzten Seite',
    pt: 'Já está na última página',
    cs: 'Již jste na poslední stránce',
    fi: 'Olet jo viimeisellä sivulla',
  },
  SelectALanguage: {
    en: 'Select a language',
    es: 'Seleccione un idioma',
    fr: 'Sélectionnez une langue',
    de: 'Wählen Sie eine Sprache',
    pt: 'Selecione um idioma',
    cs: 'Vyberte jazyk',
    fi: 'Valitse kieli',
  },
  ChuckNorrisCategory: {
    en: 'Chuck Norris Category',
    es: 'Categoría Chuck Norris',
    fr: 'Catégorie Chuck Norris',
    de: 'Chuck Norris Kategorie',
    pt: 'Categoria Chuck Norris',
    cs: 'Kategorie Chuck Norris',
    fi: 'Chuck Norris -kategoria',
  },
  FindAJoke: {
    en: 'Find a joke',
    es: 'Encuentra una broma',
    fr: 'Trouver une blague',
    de: 'Finde einen Witz',
    pt: 'Encontre uma piada',
    cs: 'Najít vtip',
    fi: 'Etsi vitsi',
  },
  Hide: {
    en: 'Hide',
    es: 'Ocultar',
    fr: 'Cacher',
    de: 'Verstecken',
    pt: 'Esconder',
    cs: 'Skrýt',
    fi: 'Piilota',
  },
  JokeIsSetToPublicAndWillNeedVerificationFromAnAdministrator: {
    en: 'Joke is set to public and will need verification from an administrator',
    es: 'La broma está configurada como pública y necesitará verificación de un administrador',
    fr: "La blague est définie sur publique et aura besoin d'une vérification de la part d'un administrateur",
    de: 'Der Witz ist auf öffentlich eingestellt und muss von einem Administrator überprüft werden',
    pt: 'A piada é definida como pública e precisará de verificação de um administrador',
    cs: 'Vtip je nastaven na veřejný a bude potřebovat ověření od správce',
    fi: 'Vitsi on asetettu julkiseksi ja se vaatii vahvistuksen hallinnolta',
  },
  JokeVerificationSucceeded: {
    en: 'Joke verified successfully',
    es: 'La broma se verificó correctamente',
    fr: 'La blague a été vérifiée avec succès',
    de: 'Der Witz wurde erfolgreich überprüft',
    pt: 'A piada foi verificada com sucesso',
    cs: 'Vtip byl úspěšně ověřen',
    fi: 'Vitsi vahvistettiin onnistuneesti',
  },
  JokeVerificationNotFound: {
    en: 'Joke not found',
    es: 'No se encontró la broma',
    fr: 'Blague introuvable',
    de: 'Witz nicht gefunden',
    pt: 'Piada não encontrada',
    cs: 'Vtip nebyl nalezen',
    fi: 'Vitsiä ei löytynyt',
  },
  JokeVerificationFailed: {
    en: 'There was a problem verifying the joke',
    es: 'Hubo un problema al verificar la broma',
    fr: 'Un problème est survenu lors de la vérification de la blague',
    de: 'Beim Überprüfen des Witzes ist ein Problem aufgetreten',
    pt: 'Ocorreu um problema ao verificar a piada',
    cs: 'Při ověřování vtipu došlo k problému',
    fi: 'Vitsin vahvistamisessa tapahtui ongelma',
  },
  RepublishingWillRequireVerificationFromAnAdministrator: {
    en: 'Republishing will require verification from an administrator',
    es: 'Volver a publicar requerirá verificación de un administrador',
    fr: "La republication nécessitera une vérification de la part d'un administrateur",
    de: 'Eine erneute Veröffentlichung erfordert eine Überprüfung durch einen Administrator',
    pt: 'Republicar exigirá verificação de um administrador',
    cs: 'Opětovné zveřejnění bude vyžadovat ověření od správce',
    fi: 'Uudelleenjulkaisu vaatii vahvistuksen hallinnolta',
  },
  TryAnotherSearchTerm: {
    en: 'Try another search term',
    es: 'Prueba otro término de búsqueda',
    fr: 'Essayez un autre terme de recherche',
    de: 'Versuchen Sie es mit einem anderen Suchbegriff',
    pt: 'Tente outro termo de pesquisa',
    cs: 'Zkuste jiný vyhledávací výraz',
    fi: 'Kokeile toisella hakuehdolla',
  },
  TryTheOtherJokeType: {
    en: 'Try the other joke type',
    es: 'Prueba el otro tipo de chiste',
    fr: "Essayez l'autre type de blague",
    de: 'Versuche den anderen Witztyp',
    pt: 'Tente o outro tipo de piada',
    cs: 'Zkuste jiný typ vtipu',
    fi: 'Kokeile toista vitsityyppiä',
  },
  MaybeTryAnotherLanguage: {
    en: 'Maybe try another language?',
    es: '¿Quizás probar otro idioma?',
    fr: 'Peut-être essayer une autre langue?',
    de: 'Vielleicht eine andere Sprache ausprobieren?',
    pt: 'Talvez tente outro idioma?',
    cs: 'Možná zkusit jiný jazyk?',
    fi: 'Kokeile ehkä toisella kielellä?',
  },
  LogoutAllDevices: {
    en: 'Logout all devices',
    es: 'Cerrar sesión en todos los dispositivos',
    fr: 'Déconnexion de tous les appareils',
    de: 'Alle Geräte abmelden',
    pt: 'Sair de todos os dispositivos',
    cs: 'Odhlásit všechna zařízení',
    fi: 'Kirjaudu ulos kaikista laitteista',
  },
  AllSessionsRevoked: {
    en: 'All sessions revoked',
    es: 'Todas las sesiones revocadas',
    fr: 'Toutes les sessions révoquées',
    de: 'Alle Sitzungen widerrufen',
    pt: 'Todas as sessões revogadas',
    cs: 'Všechny relace zrušeny',
    fi: 'Kaikki istunnot peruutettu',
  },
  ReactApps: {
    en: 'React apps',
    es: 'Aplicaciones React',
    fr: 'Applications React',
    de: 'React-Apps',
    pt: 'Aplicativos React',
    cs: 'React aplikace',
    fi: 'React-sovellukset',
  },
  IfYouDontWantToRegister: {
    en: 'If you do not want to register, you can try logging in with the test user account:',
    es: 'Si no deseas registrarte, puedes intentar iniciar sesión con la cuenta de usuario de prueba:',
    fr: 'Si vous ne souhaitez pas vous inscrire, vous pouvez essayer de vous connecter avec le compte utilisateur de test:',
    de: 'Wenn Sie sich nicht registrieren möchten, können Sie versuchen, sich mit dem Testbenutzerkonto anzumelden:',
    pt: 'Se você não quiser se registrar, pode tentar fazer login com a conta de usuário de teste:',
    cs: 'Pokud se nechcete registrovat, můžete zkusit přihlásit se pomocí testovacího uživatelského účtu:',
    fi: 'Jos et halua rekisteröityä, voit kokeilla kirjautumista testikäyttäjän tilillä:',
  },
} as const

export type Translations = typeof translations
export type TranslationKey = keyof Translations
export type TranslationLang = keyof Translations[TranslationKey]

export const generateOptionsFromT = (
  values: string[],
  language: ELanguages
): SelectOption[] => {
  return values.map((value) => ({
    label:
      translations[firstToUpperCase(value) as TranslationKey]?.[
        language as TranslationLang
      ] ?? firstToUpperCase(value),
    value: value,
  }))
}
